import ArqueoReportPage from "./ArqueoReportPage.vue";

export {ArqueoReportPage}
export default ArqueoReportPage
